module.exports = __webpack_public_path__ + "static/media/no.8021673c.svg";